export default "__VITE_ASSET__cc77ced6__"